import React, { useContext } from "react";
import {
  IconArrowRight,
  IconInfoCircle,
  IconQrcode,
  IconSparkles,
} from "@tabler/icons-react";
import { ThemeContext } from "../../theme/ThemeProvider";

const BankAccounts = () => {
  const themeContext = useContext(ThemeContext);
  if (!themeContext) {
    throw new Error("ThemeContext must be used within a ThemeProvider");
  }
  const { isDarkMode } = themeContext;

  const accounts = [
    {
      qrTitle: "Nafl",
      bank: "ICICI",
      branch: "Mothi Nagar",
      ifsc: "ICIC0002366",
      accountNumber: "236605002974",
      accountName: "TajushShariah Foundation",
      qrImage: "images/ICICI.jpg",
      qrAlt: "ICICI QR Code",
    },
    {
      qrTitle: "Wajibah",
      bank: "HDFC",
      branch: "Tolichowki",
      ifsc: "HDFC0008851",
      accountNumber: "50200088953374",
      accountName: "TajushShariah Foundation",
      qrImage: "images/HDFC.jpg",
      qrAlt: "HDFC QR Code",
    },
  ];

  return (
    <div
      id="donate"
      className={`items-center justify-center py-8 ${
        isDarkMode ? "bg-globalBg" : "bg-[#f3f4f8]"
      }`}
    >
      <div className="container m-auto px-4">
        <div
          className={`py-4 container mx-auto ${
            isDarkMode ? "bg-globalBg" : "bg-transparent"
          }`}
        >
          <h1 className="text-[#3f7ff4] text-4xl font-bold text-center mb-4">
            Support Our Mission
          </h1>

          <p
            className={`text-center max-w-3xl mx-auto mb-5 ${
              isDarkMode ? "text-gray-300" : "text-[#4b5563]"
            }`}
          >
            Your contributions help us spread Islamic knowledge and serve the
            community worldwide.
          </p>

          <section className="max-w-[980px] mx-auto px-2 mb-7">
            <div className="flex items-center justify-center gap-2 mb-3">
              <h2
                className={`text-center text-2xl font-semibold ${
                  isDarkMode ? "text-gray-100" : "text-[#1f3f75]"
                }`}
              >
                Online Donation
              </h2>
              <span className="inline-flex items-center rounded-full bg-[#ffb020] text-[#1f2a44] text-xs font-semibold px-2.5 py-1 shadow-sm">
                Recommended
              </span>
            </div>

            <div
              className={`relative overflow-hidden rounded-3xl p-6 border shadow-sm ${
                isDarkMode
                  ? "border-[#2f3f5a] bg-gradient-to-r from-[#1a2638] to-[#1f3351]"
                  : "border-[#c9dcff] bg-gradient-to-r from-[#ecf3ff] to-[#dfeaff]"
              }`}
            >
              <div className="relative z-10 flex items-center justify-center gap-2 mb-3">
                <IconSparkles
                  className={`${
                    isDarkMode ? "text-blue-300" : "text-[#2f6de0]"
                  }`}
                  size={20}
                />
                <p
                  className={`font-semibold ${
                    isDarkMode ? "text-blue-200" : "text-[#2f6de0]"
                  }`}
                >
                  Faster and easier
                </p>
              </div>

              <p
                className={`relative z-10 text-center text-base leading-7 max-w-2xl mx-auto ${
                  isDarkMode ? "text-gray-200" : "text-[#223b66]"
                }`}
              >
                We recommend you donate online and get your receipt instantly.
                This is the most convenient option for quick confirmation, clear
                tracking, and hassle-free donation management.
              </p>

              <div className="relative z-10 mt-4 flex flex-wrap justify-center gap-2">
                <span className="rounded-full px-3 py-1 text-xs font-semibold bg-white/70 text-[#23416f]">
                  Instant Receipt
                </span>
                <span className="rounded-full px-3 py-1 text-xs font-semibold bg-white/70 text-[#23416f]">
                  Easy Tracking
                </span>
                <span className="rounded-full px-3 py-1 text-xs font-semibold bg-white/70 text-[#23416f]">
                  Quick Confirmation
                </span>
              </div>

              <div className="relative z-10 flex justify-center mt-5">
                <a
                  href="/donate"
                  className="inline-flex items-center justify-center gap-2 rounded-xl bg-[#3f7ff4] px-6 py-3 text-white font-semibold shadow-sm hover:bg-[#336fe0] transition-colors"
                >
                  Donate
                  <IconArrowRight size={18} />
                </a>
              </div>
            </div>
          </section>

          <div className="flex items-center justify-center gap-2 mb-4">
            <IconQrcode
              className={`${isDarkMode ? "text-gray-200" : "text-[#1f3f75]"}`}
              size={22}
            />
            <h2
              className={`text-center text-2xl font-semibold ${
                isDarkMode ? "text-gray-100" : "text-[#1f3f75]"
              }`}
            >
              Offline Donation
            </h2>
          </div>

          <div
            className={`rounded-2xl border p-3 md:p-4 max-w-[980px] mx-auto mb-7 shadow-sm ${
              isDarkMode
                ? "border-yellow-700 bg-yellow-900/20 text-yellow-100"
                : "border-l-4 border-l-[#f59e0b] border-[#fef3c7] bg-[#fef9e7] text-[#92400e]"
            }`}
          >
            <p className="text-xs md:text-sm leading-relaxed text-justify">
              Please share your transaction details with us to receive a
              donation receipt and ensure proper fund utilization. If your
              donation is for
              <span className="font-semibold"> Wajibah </span>
              funds (Zakaat, Fitra, Wajib Sadaqah), please inform us at the
              time of donation for
              <span className="font-semibold"> Hilah Shari'ah</span>.
              Otherwise, it will be treated as
              <span className="font-semibold"> Nafli (optional) charity</span>.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-[980px] mx-auto px-2">
            {accounts.map((account) => (
              <div
                key={`${account.bank}-${account.accountNumber}`}
                className={`w-full max-w-[295px] mx-auto rounded-3xl p-5 border shadow-sm transition-transform duration-150 ease-in-out hover:-translate-y-0.5 hover:shadow-md ${
                  isDarkMode
                    ? "border-[#424242] bg-[#1b1b1b]"
                    : "border-[#e7e9ee] bg-white"
                }`}
              >
                <h3
                  className={`text-center text-lg font-semibold mb-3 ${
                    isDarkMode ? "text-gray-100" : "text-[#1f3f75]"
                  }`}
                >
                  <span className="inline-flex items-center rounded-full bg-[#edf3ff] text-[#1f3f75] px-3 py-1 text-sm">
                    {account.bank}
                  </span>
                </h3>

                <div
                  className={`w-40 h-40 rounded-2xl border mx-auto p-2 ${
                    isDarkMode ? "border-[#454545]" : "border-[#d7dce5]"
                  }`}
                >
                  <img
                    className="w-full h-full object-contain"
                    src={account.qrImage}
                    alt={account.qrAlt}
                  />
                </div>

                <div className="mt-5 text-sm">
                  <div
                    className={`grid grid-cols-[auto,1fr] gap-3 py-2 border-b ${
                      isDarkMode ? "border-[#303030]" : "border-[#edf0f5]"
                    }`}
                  >
                    <span className="text-[#9aa3b2] font-semibold">Branch</span>
                    <span
                      className={`text-right font-semibold ${
                        isDarkMode ? "text-gray-100" : "text-[#344054]"
                      }`}
                    >
                      {account.branch}
                    </span>
                  </div>

                  <div
                    className={`grid grid-cols-[auto,1fr] gap-3 py-2 border-b ${
                      isDarkMode ? "border-[#303030]" : "border-[#edf0f5]"
                    }`}
                  >
                    <span className="text-[#9aa3b2] font-semibold">IFSC Code</span>
                    <span
                      className={`text-right font-semibold ${
                        isDarkMode ? "text-gray-100" : "text-[#344054]"
                      }`}
                    >
                      {account.ifsc}
                    </span>
                  </div>

                  <div
                    className={`grid grid-cols-[auto,1fr] gap-3 py-2 border-b ${
                      isDarkMode ? "border-[#303030]" : "border-[#edf0f5]"
                    }`}
                  >
                    <span className="text-[#9aa3b2] font-semibold">Account No.</span>
                    <span
                      className={`text-right font-semibold ${
                        isDarkMode ? "text-gray-100" : "text-[#344054]"
                      }`}
                    >
                      {account.accountNumber}
                    </span>
                  </div>

                  <div className="grid grid-cols-[auto,1fr] gap-3 py-2">
                    <span className="text-[#9aa3b2] font-semibold">A/c Name</span>
                    <span
                      className={`text-right font-semibold ${
                        isDarkMode ? "text-gray-100" : "text-[#344054]"
                      }`}
                    >
                      {account.accountName}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default BankAccounts;
